import axios from 'axios'
import store from '@/store'

const urlPath = '/dps/report'

export default {
  async list(params, callback, errorCallback) {
    let apiUrl = store.state.apiSelected.apiHost
    try {
      let resp = await axios.get(`${apiUrl}${urlPath}`, {
        params: params
      })
      callback(resp.data)
    } catch (error) {
      console.log(error)
      errorCallback()
    }
  },
  async bookings(params, callback, errorCallback) {
    let apiUrl = store.state.apiSelected.apiHost
    try {
      let resp = await axios.get(`${apiUrl}${urlPath}/bookings`, {
        params: params
      })
      callback(resp.data)
    } catch (error) {
      console.log(error)
      errorCallback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/reportService.js